module.exports = __webpack_public_path__ + "static/media/CultureModeVie_PictoCdlT.ffc28183.png";